import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "dtl_access_token";

export function setStoredToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Attach Bearer token as fallback (in case httpOnly cookies are blocked
// by browser third-party-cookie policies).
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  // Structured overlap error from POST/PUT /time-entries — format the times
  // in the caller's LOCAL timezone (never UTC) so it matches what the user
  // typed on the form.
  if (detail && detail.message === "overlap" && detail.conflict) {
    const c = detail.conflict;
    const fmt = (iso) => {
      if (!iso) return "…";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: false });
    };
    const when = `${fmt(c.start)}–${fmt(c.end)}`;
    const tail = c.description ? ` (${c.description})` : c.leave_type ? ` (${c.leave_type} leave)` : "";
    const extra = detail.extra_count > 0 ? ` and ${detail.extra_count} more` : "";
    return `Overlaps an existing entry ${when}${tail}${extra}. Adjust the times so entries don't overlap.`;
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

export function formatHM(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h}h ${m}m`;
}
